// SECURITY: All endpoints MUST use /sessions/* paths (relative to /api/admin base).
// Session data includes device/browser/IP — NO tokens, NO user social data.

import apiClient from './client'
import type { AdminSession } from '@/types/session'

// ---------------------------------------------------------------------------
// Sessions API — admin session management endpoints
// ---------------------------------------------------------------------------

/**
 * Fetch all active sessions for the current admin user.
 * Returns a list of sessions with device, browser, IP, and timestamps.
 * SECURITY: Shows admin user's own sessions only (unless super_admin).
 */
export async function getSessions(): Promise<AdminSession[]> {
  const { data } = await apiClient.get<{ data: AdminSession[]; total: number }>('/sessions')
  return data.data
}

/**
 * Revoke (terminate) a single session by its ID.
 * The session owner will be logged out from that device.
 * SECURITY: Cannot revoke the current session from this endpoint.
 */
export async function revokeSession(sessionId: string): Promise<void> {
  await apiClient.delete(`/sessions/${sessionId}`)
}

/**
 * Revoke all sessions except the current one.
 * The admin user will remain logged in on the current device,
 * but all other devices will be logged out.
 */
export async function revokeAllOtherSessions(): Promise<void> {
  await apiClient.post('/sessions/revoke-all')
}
